import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ variant = 'card', count = 1 }) => {
  const renderSkeleton = () => {
    switch (variant) {
      case 'card':
        return (
          <div className="skeleton-card">
            <div className="skeleton-card__image skeleton-shimmer" />
            <div className="skeleton-card__content">
              <div className="skeleton-card__title skeleton-shimmer" />
              <div className="skeleton-card__text skeleton-shimmer" />
              <div className="skeleton-card__text skeleton-shimmer" style={{ width: '80%' }} />
              <div className="skeleton-card__button skeleton-shimmer" />
            </div>
          </div>
        );

      case 'grid':
        return (
          <div className="skeleton-grid">
            {Array.from({ length: count }).map((_, index) => (
              <div key={index} className="skeleton-card">
                <div className="skeleton-card__image skeleton-shimmer" />
                <div className="skeleton-card__content">
                  <div className="skeleton-card__title skeleton-shimmer" />
                  <div className="skeleton-card__text skeleton-shimmer" />
                  <div className="skeleton-card__text skeleton-shimmer" style={{ width: '80%' }} />
                  <div className="skeleton-card__button skeleton-shimmer" />
                </div>
              </div>
            ))}
          </div>
        );

      case 'detail':
        return (
          <div className="skeleton-detail">
            <div className="skeleton-detail__text skeleton-shimmer" style={{ width: '40%' }} />
            <div className="skeleton-detail__image skeleton-shimmer" />
            <div className="skeleton-detail__text skeleton-shimmer" style={{ width: '60%' }} />
            <div className="skeleton-detail__text skeleton-shimmer" style={{ width: '30%' }} />
            <div className="skeleton-detail__button skeleton-shimmer" />
          </div>
        );

      case 'text':
        return (
          <div className="skeleton-text-block">
            {Array.from({ length: count }).map((_, index) => (
              <div key={index} className="skeleton-text skeleton-shimmer" />
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="skeleton-loader" aria-busy="true" aria-label="Cargando contenido">
      {renderSkeleton()}
    </div>
  );
};

export default SkeletonLoader;
